(function() {
'use strict';

angular
    .module('dashboard')
    .factory('dashboardBookingService', dashboardBookingService);

function dashboardBookingService($http,
                                 $q,
                                 $routeParams,
                                 resourceService,
                                 dateUtil,
                                 broker,
                                 $location,
                                 crossSellService,
                                 customCurrencyFilter,
                                 dashboardBookingsErrorMessage,
                                 authService,
                                 bookingActionLink,
                                 imageService,
                                 $interpolate,
                                 unadjustedDateFilter,
                                 mybTrack) {
    const bookingActions = {
        VIEWBOOKINGDETAILS: {
            label: 'DASHBOARDRESOURCE_VIEWDETAILS',
            icon: 'icon-menu'
        },
        CSR: {
            label: 'DASHBOARDRESOURCE_CSR',
            icon: 'icon-support'
        },
        VOUCHERACTIONS: {
            label: 'DASHBOARDRESOURCE_RESENDEMAIL',
            icon: 'icon-email',
            trackEvent: 'MYB - Resend Email'
        },
        CHANGECONTACTDETAILS: {
            label: 'DASHBOARDRESOURCE_CHANGECONTACTDETAILS',
            icon: 'icon-edit'
        },
        CANCELBOOKINGS: {
            label: 'DASHBOARDRESOURCE_CANCELBOOKINGS',
            icon: 'icon-close',
            trackEvent: 'MYB - Cancel Click'
        },
        PAYBALANCE: {
            label: 'DASHBOARDRESOURCE_PAYBALANCE',
            icon: TRPCONFIG.Domain.CurrencyCode === 'EUR' ? 'icon-symbol-eur' : 'icon-symbol-gbp' //TODO: only two currencies?
        },
        ENTERAPI: {
            label: 'DASHBOARDRESOURCE_ENTERPASSENGERDETAILS',
            icon: 'icon-passenger'
        },
        PRINTVOUCHER: {
            label: 'DASHBOARDRESOURCE_PRINTVOUCHER',
            icon: 'icon-print',
            trackEvent: 'MYB - Print Booking'
        },
        PRINTRECEIPT: {
            label: 'DASHBOARDRESOURCE_PRINTRECEIPT',
            icon: 'icon-print',
            trackEvent: 'MYB - Print Booking'
        },
        AMENDBOOKING: {
            label: 'DASHBOARDRESOURCE_AMENDBOOKING',
            icon: 'icon-edit-booking',
            trackEvent: 'MYB - Amend Click'
        },
        ENTERREVIEW: {
            label: 'DASHBOARDRESOURCE_ENTERREVIEW',
            icon: 'icon-reviews'
        },
        ADDBAGGAGE: {
            label: 'ADDBAGGAGE',
            icon: 'icon-baggage'
        },
        DERWENTLINK: {
            label: 'DASHBOARDRESOURCE_DERWENTLINK',
            icon: 'icon-menu'
        },
        PRINTINVOICE: {
            label: 'DASHBOARDRESOURCE_PRINTINVOICE',
            icon: 'icon-print'
        }
    };

    const bookingTypes = {
        1: { template: 'flight', code: 'MANAGEFLIGHT', ticket: 'TICKETS', icon: 'icon-flights' },
        2: { template: 'tickets', code: 'MANAGETICKETS', ticket: 'TICKETS', icon: 'icon-attractions', defaultImage: '/build/img/assets/product/attractions.jpg' },
        4: { template: 'car-hire', code: 'MANAGECARHIRE', ticket: 'VOUCHERS', icon: 'icon-car-hire', defaultImage: '/build/img/assets/car_hire.jpg' },
        8: { template: 'accommodation', code: 'MANAGEACCOMODATION', ticket: 'VOUCHERS', icon: 'icon-hotels' },
        9: { template: 'holiday', code: 'MANAGEHOLIDAY' },
        16: { template: 'parking', code: 'MANAGEPARKING', icon: 'icon-parking', defaultImage: '/build/img/assets/product/parking.jpg' },
        32: { template: 'transfer', code: 'MANAGETRANSFER', icon: 'icon-transfers', defaultImage: '/build/img/assets/product/transfers.jpg' },
        64: { template: 'insurance', code: 'MANAGEINSURANCE', icon: 'icon-insurance', defaultImage: '/build/img/assets/product/travel-insurance.jpg' },
        128: { template: 'package-holidays', code: 'MANAGEPACKAGE' },
        256: { template: 'marhaba', code: 'MANAGEMARHARBA', icon: 'icon-marhaba', defaultImage: '/build/img/assets/product/marhaba.jpg' },
        1024: { template: 'bundle', code: 'MANAGEBUNDLE', icon: 'icon-stack', defaultImage: '/build/img/assets/product/bundle.jpg' },
        2048: { template: 'adhoc', code: 'MANAGEADHOC', icon: 'icon-attractions', defaultImage: '/build/img/assets/product/adhoc.jpg' }
    };
    const bookingTypeMap = {
        accommodation: 8,
        flight: 1,
        attraction: 2,
        carhire: 4,
        transfer: 32,
        travelInsurance: 64,
        bundle: 1024
    };
    const bookingInfoItemType = {
        Generic: 1,
        CancellationCondition: 2
    };
    const baseManageUrl = '/api2/managebooking';
    const v2ManageUrl = '/api2/bookings/manage';
    const bookingStatus = {
        confirmed: 1,
        pending: 2,
        canceled: 3
    };
    let limitBooking = 10;
    const itineraryType = {
        FlightOutbound: 1,
        FlightInbound: 2,
        CarHire: 3,
        HotelRoom: 4,
        AttractionTicket: 5,
        FlightInfo: 6,
        CarParking: 7,
        TransferArrival: 8,
        TransferReturn: 9,
        Insurance: 10,
        PackageHoliday: 11,
        Marhaba: 13
    };
    let tripsPromiseCache = {};
    const destinationType = {
        None: 0,
        Establishment: 1,
        Location: 2,
        Province: 3,
        Country: 4,
        Place: 5,
        Polygon: 10,
        Universal: 12
    };
    const bookingImageWidth = 300;
    const bookingImageHeight = 190;

    const service = {
        getBookingDetailsForTrip,
        getOutstandingTrips,
        getBookingStatus: () => angular.copy(bookingStatus),
        getBookingTypeMap: () => angular.copy(bookingTypeMap),
        getBookingInfoItemType: () => angular.copy(bookingInfoItemType),
        getLimitBooking: () => limitBooking,
        getItineraryType: () => angular.copy(itineraryType),
        getBookingDetail,
        getFuturePayments,
        getBookingSummary,
        getConfirmationEmailInfo,
        getActionLinks: () => bookingActionLink.get(),
        formatTitle,
        sendConfirmationEmail,
        getContact,
        putContact,
        removeCanceledBookings,
        calculateType,
        formatBookingMessage,
        setLimitBooking,
        getBookingInfo,
        getObjectFromBooking,
        actionClick,
        getChildActions,
        getPahFromNotifications,
        getBookingActions,
        translateActionLink,
        getTripTitle,
        getFlightBooking,
        isPartOfHoliday,
        getMybBooking,
        getTripDateText
    };

    function calculateType(abbr) {
        return bookingTypes[abbr] || abbr;
    }

    function getBookingActions() {
        return angular.copy(bookingActions);
    }

    // Gets the list of trips linked to the user
    function _getTripsInformation(period, tripId) {
        return $http.post(
            'website/dashboard/trips/information',
            {
                Period: period,
                TripId: tripId
            }
        ).then(function(res) {
            if (!res || !res.data || !res.data.Trips || (!res.data.Trips.length && tripId) || res.data.InValidOwner) {
                return _bookingOwnershipRejection(tripId);
            }
            return res.data.Trips;
        });
    }

    function getBookingDetailsForTrip(tripId) {
        return $http.post(`${v2ManageUrl}/getbookingdetailsfortrip`, { TripId: tripId, CultureCode: TRPCONFIG.Domain.CultureCode })
            .then(res => {
                const bookingDetails = angular
                    .copy(res.data.BookingDetails)
                    .filter(d => d.BookedItems && d.BookedItems.length && d.Booking && d.LeadPassenger);
                bookingDetails.forEach(detail => {
                    if (detail.Booking) {
                        detail.Booking.LongType = calculateType(detail.Booking.Type);
                    }
                });
                return bookingDetails;
            });
    }

    function getOutstandingTrips(period, tripId, crossSell = false) {
        if (tripsPromiseCache[period]) {
            return tripsPromiseCache[period];
        }
        if (tripId && tripsPromiseCache.reference && tripsPromiseCache.reference[tripId]) {
            return tripsPromiseCache.reference[tripId];
        }

        const tripsPromise = _getTripsInformation(period, tripId)
        .then(function _parseOutstandingTrip(trips) {
            ['userSet', 'bookingComplete', 'paymentComplete', 'reviewEntered', 'csrRaised', 'apiAdded']
            .forEach(event => broker.subscribe('dashboardBookingService', event, () => tripsPromiseCache = {}));

            if (trips && trips.length) {
                trips[0].isExpanded = true;

                if (tripId && trips.length === 1) {
                    trips[0].Bookings[0].showOptions = true;
                }

                trips.forEach(function(tr) {
                    tr.Bookings.forEach(function(bk) {
                        bk.LongType = calculateType(bk.Type);
                        _createActionList(bk);
                        _addBookingImage(bk);
                    });
                    _processPackageTripIfNeeded(tr);
                });

                const flightBooking = _.find(trips[0].Bookings, b => b.Type === 1);
                if (flightBooking && !flightBooking.ObjectId) {
                    service.getObjectFromBooking(flightBooking.BookingId).then(obj =>
                        flightBooking.ImageUrl = imageService.getDestinationImage(obj, bookingImageWidth, bookingImageHeight)
                    );
                }

                if (crossSell) {
                    crossSellService.addExtrasAndCrossSells(trips[0]);
                }
            }
            return trips;
        });

        if (period) {
            tripsPromiseCache[period] = tripsPromise;
        } else {
            if (!tripsPromiseCache.reference) {
                tripsPromiseCache.reference = {};
            }
            tripsPromiseCache.reference[tripId] = tripsPromise;
        }

        return tripsPromise;
    }

    function getTripTitle(tr) {
        return _.uniqBy(tr.Bookings, 'Type').reduce((title, bk, index) =>
            title + (index ? ' + ' : '') + resourceService.get(bk.LongType.code), '');
    }

    function isPartOfHoliday(bookingId) {
        return getOutstandingTrips(null, bookingId).then(trips =>
            _.every(trips, tr => _.some(tr.Bookings, bk => bk.Type === bookingTypeMap.flight)
                && _.some(tr.Bookings, bk => bk.Type === bookingTypeMap.accommodation))
        );
    }

    function getTripDateText(tr) {
        const bookings = angular.copy(tr.Bookings);
        const cancelled = _.remove(bookings, bk => bk.Status === bookingStatus.canceled);
        const oldBookings = _.remove(bookings, bk => dateUtil.compareDates(bk.ReturnDate, dateUtil.todayPlus(0, 0, true)) === -1);
        if (cancelled.length === tr.Bookings.length) {
            return resourceService.get('TRIPCANCELLED');
        }
        const bookingsForTrip = bookings.length ? bookings : oldBookings;
        if (bookingsForTrip.length > 0) {
            return `${resourceService.get('TRIPDATE')} ${unadjustedDateFilter(_.reduce(bookingsForTrip, (startDate, bk) =>
            (dateUtil.compareDates(bk.StartDate, startDate) === -1) ? bk.StartDate : startDate, bookingsForTrip[0].StartDate), 'dd MMM yyyy')}`;
        }
    }

    function _createActionList(booking) {
        booking.BookingOptions.Actions.map(a => {
            const action = bookingActions[a.Name];
            a.label = action ? action.label : a.Name;
            if (action) {
                a.icon = action.icon;
                a.trackEvent = action.trackEvent;
            }
            return a;
        });
    }

    function _addBookingImage(bk) {
        if (bk.Type === bookingTypeMap.accommodation) {
            bk.ImageUrl = imageService.getMainImageUrl(bk.ObjectId, bookingImageWidth, bookingImageHeight, true);
        }
        if (!bk.ImageUrl) {
            bk.ImageUrl = bookingTypes[bk.Type].defaultImage;
        }
    }

    function _processPackageTripIfNeeded(trip) {
        const [hotelBooking, flightBooking] = [8, 1].map(type => _.chain(trip)
            .get('Bookings')
            .find(['Type', type]));

        const removePayBalance = [hotelBooking, flightBooking].every(booking =>
            booking.get('PackageId').value());

        if (removePayBalance) {
            const messages = _.chain([flightBooking, hotelBooking])
                .map(booking => booking.pick(['BalanceDueInfo', 'BookingId']).value())
                .filter('BalanceDueInfo')
                .value();

            const actions = _.chain([flightBooking, hotelBooking]).flatMap(booking => {
                booking.unset('BalanceDueInfo')
                    .value();
                booking.get('TopInfoTexts')
                    .remove(info => info && info.type === 8)
                    .value();
                return booking.get('BookingOptions.Actions')
                    .remove(action => action && action.Name === 'PAYBALANCE')
                    .value();
            }).value();

            trip.packagePaymentsData = _.zipWith(messages, actions, (message, action) => _.defaults(
                message,
                { Action: action }
            ));
        }
    }

    function getObjectFromBooking(bookingId) {
        const obj = {};
        return service.getFlightBooking(bookingId).then(function(result) {
            const bookedItems = result.data;
            const destinationAirportCode = _.find(bookedItems.Itineraries, i => i.ItineraryTypeId === 1).DestinationAiport;
            return $http.get(`/api2/destination/airports/getairportlocation?${$.param({
                airportCode: destinationAirportCode,
                cultureCode: TRPCONFIG.Domain.CultureCode })}`, { ignoreErrors: true }
                    ).then(function(r) {
                        const destination = r.data;
                        obj.ObjectId = destination.LocationId !== 0 ? destination.LocationId : destination.ProvinceId;
                        obj.ObjectTypeId = destination.LocationId !== 0 ? destinationType.Location : destinationType.Province;
                return obj;
            });
        });
    }

    function getFlightBooking(bookingId) {
        return $http.get(`/api2/flightsnew/booking/${bookingId}`, { cache: true, ignoreErrors: true });
    }

    function getBookingInfo(bookingId) {
        return getOutstandingTrips(null, bookingId, true).then(function(trips) {
            return _.find(trips[0].Bookings, function(bk) {
                return bk.BookingId === parseInt(bookingId);
            });
        });
    }

    function setLimitBooking(n) {
        limitBooking = n;
    }

    function actionClick(action, booking) {
        const actionLink = service.getActionLinks();
        if (action.disabled) {
            return false;
        }

        if (TRPCONFIG.Domain2.BookingCtaRedirectEnabled) {
            const enableRedirect = ['CANCELBOOKINGS', 'CSR', 'AMENDBOOKING'].includes(action.Name);

            if (enableRedirect) {
                window.open(TRPCONFIG.Domain2.BookingCtaRedirectUrl, '_blank');
                return false;
            }
        }

        if (actionLink) {
            if (action.trackEvent) {
                mybTrack.track(action.trackEvent);
            }
            const path = translateActionLink(actionLink[action.Name], booking);
            if (action.OpenNewTab) {
                window.open(path, '_blank');
                return false;
            }
            $location.url(path);
        }
    }

    function translateActionLink(link, booking) {
        return link ? $interpolate(link)(booking) : '';
    }

    const TopInfo =
    {
        PayAtHotel: 7
    };

    const notificationData = {
        3: 'BalanceDue',
        7: 'PayAtHotel'
    };

    function formatBookingMessage(info, bk) {
        let resourceVal = resourceService.get(info.text);
        if (info.action.Name) {
            const actionLink = service.getActionLinks();
            const actionPath = translateActionLink(actionLink[info.action.Name], bk);
            resourceVal = String.format(resourceVal, actionPath);
        }
        switch (info.type) {
            case TopInfo.PayAtHotel: {
                const pah = getPahFromNotifications(bk.Notifications);
                return pah ? String.format(resourceVal, customCurrencyFilter(pah.Amount, pah.CurrencyCode)) : '';
            }
        }

        return resourceVal;
    }

    function getPahFromNotifications(notifications) {
        return _.reduce(notifications, (pah, n) => {
            if (TopInfo.PayAtHotel === TopInfo[notificationData[n.Type]]) {
                pah.Amount += n.Amount;
                pah.CurrencyCode = n.CurrencyCode;
            }
            return pah;
        }, { Amount: 0 });
    }

    function removeCanceledBookings(trips) {
        const filteredTrips = [];
        _.forEach(trips, t => {
            t.Bookings = _.filter(t.Bookings, b => b.Status !== bookingStatus.canceled);
            if (t.Bookings.length > 0) {
                filteredTrips.push(t);
            }
        });
        return filteredTrips;
    }

    // Gets details regarding a booking and adds full booking type
    function getBookingDetail(bookingId, viewDetail = false) {
        const cultureCode = TRPCONFIG.Domain.CultureCode;
        const promise = viewDetail
            ? $http.get(
                `website/bookingdetails/${bookingId}/${cultureCode}`
            ) : $http.post(
                `${v2ManageUrl}/getbookingdetailv2`,
                { BookingId: bookingId, Culture: cultureCode }
            );

        return promise.then(res => {
            if (!res || !res.data) {
                return;
            }
            if (res.data.InValidOwner) {
                return _bookingOwnershipRejection(bookingId);
            }
            if (viewDetail) {
                return parseBooking(res.data);
            }
            return res.data;
        });
    }

    function getFuturePayments(booking) {
        if (!booking) {
            return $q.when();
        }
        return getBookingDetail(booking.BookingId, true).then(details => _.get(details, 'FuturePayments'))
            .then(fp => booking.FuturePayments = fp);
    }

    function parseBooking(detail) {
        const booking = detail.Booking;
        booking.LongType = calculateType(booking.Type);

        const passengerTitles = {
            accommodation: {
                plural: 'GUESTS',
                singular: 'LEADGUEST'
            },
            tickets: {
                plural: 'VISITORS',
                singular: 'VISITOR'
            },
            defaultTitle: {
                plural: 'PASSENGERS',
                singular: 'PASSENGER'
            }
        };

        const titles = passengerTitles[booking.LongType.template] || passengerTitles.defaultTitle;
        booking.PassengersTitlePlural = resourceService.get(titles.plural);
        booking.PassengersTitleSingular = resourceService.get(titles.singular);

        return detail;
    }

    // Gets booking summary
    function getBookingSummary(bookingId) {
        return $http.get(
            `${v2ManageUrl}/bookingsummary?bookingId=${bookingId}`, { ignoreErrors: true }
        ).then(function(result) {
            return result.data;
        });
    }

    // Gets details regarding the confirmation email
    function getConfirmationEmailInfo(bookingId) {
        const cultureCode = TRPCONFIG.Domain.CultureCode;
        return $http.post(
            `${baseManageUrl}/getconfirmationemailinfo`,
            { BookingId: bookingId, Culture: cultureCode }
        );
    }

    // Gets contact
    function getContact(bookingId) {
        return $http.get(
            `${v2ManageUrl}/contactdetails/${bookingId}`
        );
    }

    // updates contact
    function putContact(bookingId, contactDetail, updateRelatedBookings) {
        if (updateRelatedBookings) {
            contactDetail.BookingId = bookingId;
            return $http.post(
                String.format('{0}/{1}/{2}', v2ManageUrl, 'contactdetails', 'updatecontactdetailsforlinkedbookings'), contactDetail);
        }

        return $http.put(
            String.format('{0}/{1}/{2}', v2ManageUrl, 'contactdetails', bookingId), contactDetail);
    }

    // Format the Title by removing the supplier name
    function formatTitle(bk) {
        //If not Insurance booking
        if (bk.Type !== bookingTypeMap.travelInsurance && bk.Type !== bookingTypeMap.bundle && bk.Title) {
            const titleArray = bk.Title.split(':');
            bk.Title = (titleArray.length > 1) ? titleArray[1].trim() : titleArray[0];
        }
    }

    //Resend Email Confirmation
    function sendConfirmationEmail(emails, bookingId) {
        return $http.post(`${baseManageUrl}/sendconfirmationemail`,
                    {
                        BookingId: bookingId,
                        Culture: TRPCONFIG.Domain.CultureCode,
                        Emails: emails
                    }
                );
    }

    function _bookingOwnershipRejection(id) {
        dashboardBookingsErrorMessage.setMessage(id);
        const user = authService.getUser();
        if (user.HardSignedIn) {
            $location.path('/dashboard/bookings/current');
        }
        const bookingId = authService.getSignedInBookingId();
        if (bookingId) {
            $location.path(`/dashboard/bookings/reference/${bookingId}`);
        }
        return $q.reject();
    }

    function getChildActions(actions, parent) {
        return _.filter(actions, function(a) {
            return a.ParentActionName === parent;
        });
    }

    function getMybBooking(BookingId = $routeParams.BookingId) {
        return $http.get('/api/bookings/myb/getbooking', {
            params: {
                BookingId,
                CultureCode: TRPCONFIG.Domain.CultureCode,
            },
            cache: true,
        })
        .then(({ data }) => data);
    }

    return service;
}
})();
